@if (saleId > 0) {
<div id="sale-product-content" class="card">
    <div class="card-body">
        <form [formGroup]="form">
            <ng-container formArrayName="saleProductsList">
                <ul>
                    <li class="header">
                        <p class="text-left">Product</p>
                        <p class="text-left">Company</p>
                        <p class="text-right">Cost</p>
                        <p class="text-right">Price</p>
                        <p></p>
                    </li>
                    @for (saleProductForm of saleProductsList.controls; track saleProductForm; let i = $index) {
                        <li [formGroup]="saleProductForm">
                            <div class="align-items-center d-flex">{{ saleProductForm.get('productName').value }}</div>
                            <contact-advanced-search [type]="saleProductForm.get('contactRoleType').value" [key]="saleProductForm.get('productName').value.toLowerCase().replace(' ', '-')" [contactNameSaved]="saleProductForm.get('contactName').value" [contactIdSaved]="saleProductForm.get('contactId').value" [displayLabel]="false" (setContactId)="setContactIdEvent($event, i)" [isDisabled]="!isUnLock"></contact-advanced-search>
                            <currency-input [id]="'productDealerCost' + i" (committed)="changed($event, i)" (blurred)="changed($event, i)" [control]="saleProductForm.get('dealerCost')"></currency-input>
                            <currency-input [id]="'productSellingPrice' + i" (committed)="changed($event, i)" (blurred)="changed($event, i)" [control]="saleProductForm.get('sellingPrice')"></currency-input>
                            <div class="actions">
                                <button type="button" title="Remove Product" class="btn btn-sm btn-link" (click)="discardProduct(i)" [disabled]="!isUnLock"><span class="dripicons dripicons-trash text-danger"></span></button>
                            </div>
                        </li>
                    }
                    @if (saleProductsList.controls.length > 0) {
                        <li class="totals">
                            <p class="text-left"></p>
                            <p class="text-left"></p>
                            <p class="text-right">{{cost | currency}}</p>
                            <p class="text-right">{{total | currency}}</p>
                            <p></p>
                        </li>
                    }
                </ul>
            </ng-container>
        </form>
        <div class="button-bar text-right">
            <div class="dropdown">
                <button type="button" class="btn btn-success btn-sm dropdown-toggle" id="addProductMenu" data-toggle="dropdown" aria-expanded="false" [disabled]="!isUnLock">
                    <span class="dripicons dripicons-plus"></span>
                </button>
                <div class="dropdown-menu">
                    @for (product of selectableProducts; track product) {
                        <a class="dropdown-item" (click)="add(product)">{{product.name}}</a>
                    }
                    @empty {
                        <small>No more products available to add.</small>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
}